import { GridLayout } from "../../../../Models/GridLayout";

export const createHeaderGridVars = (layout: GridLayout): React.CSSProperties =>
  ({
    "--header-columns": layout.columns,
    "--header-areas": layout.areas,
  }) as React.CSSProperties;

export const createMainGridVars = (layout: GridLayout): React.CSSProperties =>
  ({
    "--main-columns": layout.columns,
    "--main-rows": layout.rows || "auto",
    "--main-areas": layout.areas,
  }) as React.CSSProperties;

export const createCardInformationCostGridVars = (
  layout: GridLayout,
): React.CSSProperties =>
  ({
    "--service-columns": layout.columns,
    "--service-areas": layout.areas,
  }) as React.CSSProperties;

export const createGeneralInformationGridVars = (
  layout: GridLayout,
): React.CSSProperties =>
  ({
    "--general-info-columns": layout.columns,
    "--general-info-areas": layout.areas,
  }) as React.CSSProperties;
